import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Entry Date' },
    { value: 2, label: 'Exit Date' },
    { value: 3, label: 'Departure Reason' },
  ],
});
